import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

// tslint:disable-next-line: typedef
export const isLoading = <T>(stateChanged: (state: boolean) => void) =>
  function wrapOperatorFunction(source: Observable<T>): Observable<T> {
    stateChanged(true);
    return source.pipe(finalize(() => stateChanged(false)));
  };
